module.exports = __webpack_public_path__ + "aa9f45882.jpg";